var _a;
export var ICON_STYLE_TYPES;
(function (ICON_STYLE_TYPES) {
    ICON_STYLE_TYPES["ROUNDED"] = "rounded";
    ICON_STYLE_TYPES["OUTLINED"] = "outlined";
    ICON_STYLE_TYPES["SHARP"] = "sharp";
})(ICON_STYLE_TYPES || (ICON_STYLE_TYPES = {}));
export var FONT_FAMILIES = (_a = {},
    _a[ICON_STYLE_TYPES.ROUNDED] = "Material Symbols Rounded",
    _a[ICON_STYLE_TYPES.OUTLINED] = "Material Symbols Outlined",
    _a[ICON_STYLE_TYPES.SHARP] = "Material Symbols Sharp",
    _a);
